import React, { useState, useEffect } from "react";
import './comment.css'

export default function Commentdata() {
  const [comments, setComments] = useState([]);

  const loadComments = async () => {
    try {
      const response = await fetch(`http://185.164.73.170:5001/api/comments`);
      const data = await response.json();
      setComments(data);
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    loadComments();
  }, []);

  const updateCommentStatus = async (id, status) => {
    try {
      await fetch(`http://185.164.73.170:5001/api/comments/${id}/status`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ status }),
      });
      loadComments();
    } catch (error) {
      console.error("Error updating comment status:", error);
    }
  };

  const deleteComment = async (id) => {
    try {
      await fetch(`http://185.164.73.170:5001/api/comments/${id}`, {
        method: "DELETE",
      });
      loadComments();
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  return (
    <div className="commentdatapage">
      <h2>نظرات کاربران</h2>
      {comments.map((comment) => (
        <div key={comment.id} className="commentdata">
          <h3>{comment.user}</h3>
          <p>{comment.text}</p>
          <p>امتیاز: {"⭐".repeat(comment.rating)}</p>
          <p>وضعیت: {comment.status === 'approved' ? 'تایید شده' : 'عدم تایید'}</p> {/* نمایش وضعیت نظر */}
          <button onClick={() => updateCommentStatus(comment.id, "approved")}>تایید</button>
          <button onClick={() => updateCommentStatus(comment.id, "rejected")}>عدم تایید</button>
          <button onClick={() => deleteComment(comment.id)}>حذف</button>
        </div>
      ))}
    </div>
  );
}
